export enum HandicapEquipment {
  Walking = 1,
  Wheelchair,
  ElectricWheelchair,
  Carriage,
}
